// import React, { useEffect, useState } from "react";
// import productAPI from "../../api/productApi";
// import Product from "../products/Card";
// import { Link } from "react-router-dom";

// function SearchCanvas({ isOpen, searchText, setSearchText }) {
//   const [loading, setLoading] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [page, setPage] = useState(1);

//   // const [searchText, setSearchText] = useState("");

//   useEffect(() => {
//     if (!searchText) {
//       setProducts([]);
//       return;
//     }

//     const delay = setTimeout(() => {
//       fetchProducts(1, searchText);
//     }, 400);

//     return () => clearTimeout(delay);
//   }, [searchText]);

//   const fetchProducts = async (pageNum = 1, searchText) => {
//     setLoading(true);

//     try {
//       if (searchText) {
//         const res = await productAPI.listing({
//           page: pageNum,
//           limit: 6,
//           keyword: searchText,
//         });

//         if (res.code === 200) {
//           const { products, base_url } = res.data;

//           const items = products;

//           setProducts((prev) => (pageNum === 1 ? items : [...prev, ...items]));
//         }
//       }
//     } catch (err) {
//       console.error("Error loading products:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // if (!isOpen || !searchText) return null;
//   if (!isOpen ) return null;

//   return (
//     <>
//     {searchText && (
//     <div className="search-dropdown">
      
//       {loading && <p className="p-2">Loading...</p>}

//       {!loading && products.length === 0 && (
//         // <p className="p-2">No products found</p>
//           <div className="custom-search-result-card">
//     <div className="custom-search-result-no-data">
//       No products found
//     </div>
//   </div>
//       )}

//       {searchText && (
//         <>
//           {loading && <p>Loading...</p>}

//           {products.map((product) => {
//             const image = product?.thumbnail || product?.images?.[0];

//             const price = product?.variants?.[0]?.price || product?.price;

//             return (
//               <Link
//                 to={`/shop/${product.slug}`}
//                 className="custom-search-result-card text-decoration-none"
//                 key={product._id}
//               >
//                 <img src={image} className="search-img" alt={product.title} />
//                 <div>
//                   <p className="search-title">{product.title}</p>
//                   <p className="search-price">₹{price}</p>
//                 </div>
//               </Link>
//             );
//           })}
//         </>
//       )}
//     </div>
//     )}
//     </>
//   );
// }

// export default SearchCanvas;







import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import { Link } from "react-router-dom";

function SearchCanvas({ isOpen, searchText, setSearchText }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!searchText) {
      setProducts([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchProducts(1, searchText);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, searchText) => {
    setLoading(true);

    try {
      if (searchText) {
        const res = await productAPI.listing({
          page: pageNum,
          limit: 6,
          keyword: searchText,
        });

        if (res.code === 200) {
          const { products } = res.data;
          setProducts((prev) => (pageNum === 1 ? products : [...prev, ...products]));
        }
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {searchText && (
        <div
          className="absolute left-0 right-0 top-full mt-2 z-50 rounded-2xl border border-[var(--color-border)] bg-[var(--color-bg)] p-2 shadow-2xl backdrop-blur-md overflow-y-auto lg:max-h-[420px] max-h-[calc(100vh-140px)] transition-all duration-300 animate-fadeIn"
          style={{
            WebkitOverflowScrolling: "touch",
          }}
        >
          {loading && (
            <div className="flex items-center justify-center py-6 text-sm font-medium" style={{ color: "var(--color-text-muted)" }}>
              <svg className="mr-2 h-4 w-4 animate-spin" style={{ color: "var(--color-primary)" }} viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Searching products...
            </div>
          )}

          {!loading && products.length === 0 && (
            <div className="custom-search-result-card py-8 text-center">
              <div className="custom-search-result-no-data text-sm font-medium" style={{ color: "var(--color-text-muted)" }}>
                No products found
              </div>
            </div>
          )}

          {!loading && products.length > 0 && (
            <div className="flex flex-col gap-1.5">
              {products.map((product) => {
                const image = product?.thumbnail || product?.images?.[0];
                const price = product?.variants?.[0]?.price || product?.price;

                return (
                  <Link
                    to={`/shop/${product.slug}`}
                    className="custom-search-result-card group flex items-center gap-3.5 rounded-xl p-2.5 transition-all duration-300 hover:bg-[var(--color-bg-alt)] text-decoration-none animate-slideUp"
                    key={product._id}
                  >
                    <img 
                      src={image} 
                      className="search-img h-14 w-14 flex-shrink-0 rounded-lg object-cover border border-[var(--color-border)] shadow-sm transition-transform duration-300 group-hover:scale-105" 
                      alt={product.title} 
                    />
                    <div className="flex flex-col justify-center overflow-hidden">
                      <p className="search-title truncate text-sm font-semibold transition-colors group-hover:text-[var(--color-primary)]" style={{ color: "var(--color-text)" }}>
                        {product.title}
                      </p>
                      <p className="search-price mt-0.5 text-sm font-bold" style={{ color: "var(--color-black)" }}>
                        ₹{price}
                      </p>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default SearchCanvas;